export const BoltStarAnalyticsEvents = {
  LEVELS_AND_BENEFITS_DRAWER_OPENED: 'Bolt Star Levels And Benefits Drawer Opened',
  HOW_IT_WORKS_SECTION_SEEN: 'Bolt Star How It Works Section Seen',
  HOW_IT_WORKS_BENEFITS_AND_GOALS_TOGGLED: 'Bolt Star How It Works Benefits And Goals Toggled',
  PERFORMANCE_GOAL_CARD_CLICKED: 'Bolt Star Performance Goal Card Clicked',
  MONTHLY_UPDATE_POPUP_SHOWN: 'Bolt Star Monthly Update Popup Shown',
  MONTHLY_UPDATE_POPUP_CLOSED: 'Bolt Star Monthly Update Popup Closed',
  ONBOARDING_POPUP_SHOWN: 'Bolt Star Onboarding Popup Shown',
  ONBOARDING_POPUP_CLOSED: 'Bolt Star Onboarding Popup Closed',
} as const;

export type BoltStarAnalyticsEvents =
  (typeof BoltStarAnalyticsEvents)[keyof typeof BoltStarAnalyticsEvents];

export const BenefitsDialogSource = {
  PERFORMANCE_STATUS: 'performance_status',
  HOW_IT_WORKS_TABLE: 'how_it_works_table',
} as const;

export type BenefitsDialogSource = (typeof BenefitsDialogSource)[keyof typeof BenefitsDialogSource];

export const PopupClosingType = {
  CLOSE_BUTTON: 'close_button',
  CALL_TO_ACTION: 'call_to_action',
  DISMISS_BUTTON: 'dismiss_button',
} as const;

export type PopupClosingType = (typeof PopupClosingType)[keyof typeof PopupClosingType];

export const OnboardingPopupVariant = {
  DEFAULT: 'default',
  BOLT_STAR_PAGE: 'bolt_star_page',
} as const;

export type OnboardingPopupVariant =
  (typeof OnboardingPopupVariant)[keyof typeof OnboardingPopupVariant];
